"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITOP_TICKET_INCIDENT_USER_SATISFACTION = exports.ITOP_TICKET_INCIDENT_USER_SATISFACTION_MAP = exports.ITOP_TICKET_INCIDENT_RESOLUTION_CODE = exports.ITOP_TICKET_INCIDENT_ESCALATION_FLAG = exports.ITOP_TICKET_INCIDENT_ORIGIN = exports.ITOP_TICKET_INCIDENT_PRIORITY = exports.ITOP_TICKET_INCIDENT_STATUS = void 0;
exports.ITOP_TICKET_INCIDENT_STATUS = {
    ASSIGNED: 'assigned',
    CLOSED: 'closed',
    ESCALATED_TTO: 'escalated_tto',
    ESCALATED_TTR: 'escalated_ttr',
    NEW: 'new',
    PENDING: 'pending',
    RESOLVED: 'resolved',
};
/**
 * NOTE: DID NOT FIND ANY VALUES TO MAP THESE NUMBERS TO
 */
exports.ITOP_TICKET_INCIDENT_PRIORITY = {
    '1': 1,
    '2': 2,
    '3': 3,
    '4': 4,
};
exports.ITOP_TICKET_INCIDENT_ORIGIN = {
    INTRANET: 'Intranet',
    MAIL: 'mail',
    MONITORING: 'monitoring',
    PHONE: 'phone',
    PORTAL: 'portal',
};
exports.ITOP_TICKET_INCIDENT_ESCALATION_FLAG = {
    YES: 'yes',
    NO: 'no',
};
exports.ITOP_TICKET_INCIDENT_RESOLUTION_CODE = {
    ASSISTANCE: 'assistance',
    BUG_FIXED: 'bug fixed',
    HARDWARE_REPAIR: 'hardware repair',
    OTHER: 'other',
    SOFTWARE_PATCH: 'software patch',
    SYSTEM_UPDATE: 'system update',
    TRAINING: 'training',
};
exports.ITOP_TICKET_INCIDENT_USER_SATISFACTION_MAP = {
    1: 'Muy Satisfecho',
    2: 'Satisfecho',
    3: 'Insatisfecho',
    4: 'Muy Insatisfecho',
};
exports.ITOP_TICKET_INCIDENT_USER_SATISFACTION = {
    MUY_SATISFECHO: 1,
    SATISFECHO: 2,
    INSATISFECHO: 3,
    MUY_INSATISFECHO: 4,
};
